let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dYKS0")).then(() => parcelRequire('9u7hm'));